<div
  data-testid="unassign-roles-dialog-container"
  class="unassign-roles-dialog p-4 flex flex-col gap-4 w-full overflow-x-hidden max-w-full"
>
  <nav class="flex border-b border-gray-200 -mb-px">
    <button
      data-testid="unassign-roles-dialog-tab-roles"
      type="button"
      class="px-4 py-2 text-sm font-medium border-b-2 transition-colors"
      [class.border-blue-500]="activeTab() === 'roles'"
      [class.text-blue-600]="activeTab() === 'roles'"
      [class.border-transparent]="activeTab() !== 'roles'"
      [class.text-gray-500]="activeTab() !== 'roles'"
      (click)="setTab('roles')"
    >
      {{ "configuration.user_roles_assignment.dialog.tab_roles" | translate }}
    </button>
    <button
      data-testid="unassign-roles-dialog-tab-business-unit"
      type="button"
      class="px-4 py-2 text-sm font-medium border-b-2 transition-colors"
      [class.border-blue-500]="activeTab() === 'bu'"
      [class.text-blue-600]="activeTab() === 'bu'"
      [class.border-transparent]="activeTab() !== 'bu'"
      [class.text-gray-500]="activeTab() !== 'bu'"
      (click)="setTab('bu')"
    >
      {{ "configuration.user_roles_assignment.dialog.tab_bu" | translate }}
    </button>
  </nav>

  @if (activeTab() === "roles") {
    <div
      class="roles-table-section flex-1 min-h-0 w-full overflow-x-hidden min-w-0"
    >
      <h4 class="text-sm font-semibold text-gray-700 mb-2">
        {{
          "configuration.user_roles_assignment.dialog.select_roles_to_unassign"
            | translate
        }}
      </h4>
      <app-data-table
        data-testid="unassign-roles-dialog-roles-table"
        [dataSource]="roles()"
        [columns]="columns"
        [loading]="false"
        [hasCheckColumn]="true"
        [selection]="selectedRoles()"
        [scrollHeight]="'300px'"
        [tableStyle]="{
          width: '100%',
          minWidth: '0',
          maxWidth: '100%',
          tableLayout: 'fixed',
        }"
        [showPaginator]="false"
        (selectionChange)="onSelectionChange($event)"
        class="w-full unassign-roles-table"
      >
      </app-data-table>
    </div>
  }

  @if (activeTab() === "bu") {
    <div
      class="bu-table-section flex-1 min-h-0 w-full overflow-x-hidden min-w-0"
    >
      <h4 class="text-sm font-semibold text-gray-700 mb-2">
        {{
          "configuration.user_roles_assignment.dialog.select_bu_to_unassign"
            | translate
        }}
      </h4>
      <app-data-table
        data-testid="unassign-roles-dialog-business-unit-table"
        [dataSource]="buItems()"
        [columns]="buColumns"
        [loading]="buLoading()"
        [hasCheckColumn]="true"
        [selection]="selectedBuItems()"
        [scrollHeight]="'300px'"
        [tableStyle]="{
          width: '100%',
          minWidth: '0',
          maxWidth: '100%',
          tableLayout: 'fixed',
        }"
        [showPaginator]="false"
        (selectionChange)="onBuSelectionChange($event)"
        class="w-full unassign-bu-table"
      >
      </app-data-table>
    </div>
  }

  <div class="flex justify-end gap-3 pt-4 border-t border-gray-200">
    <app-button
      [testId]="'unassign-roles-dialog-cancel-btn'"
      [label]="'common.actions.cancel' | translate"
      type="secondary"
      [outlined]="true"
      (emitOnClick)="onCancel()"
    ></app-button>
    <app-button
      [testId]="'unassign-roles-dialog-confirm-btn'"
      [label]="
        'configuration.user_roles_assignment.actions.unassign_roles' | translate
      "
      type="info"
      [disabled]="!canConfirm()"
      (emitOnClick)="onConfirm()"
    ></app-button>
  </div>
</div>
